import { createFileRoute, notFound } from "@tanstack/react-router";
import { loadLocale } from "@/i18n/load-locale";
import { isLocale } from "@/lib/locales";

/**
 * `/de`, `/de/pricing`, …: the public pages that exist in every language (src/lib/locales.ts). The prefix picks the
 * language and its strings load before the page renders; any other first segment is no page.
 */
export const Route = createFileRoute("/_marketing/$lang")({
  beforeLoad: async ({ params }) => {
    if (!isLocale(params.lang)) throw notFound();
    // Offline, the strings may not load: the page then shows in English rather than an error.
    await loadLocale(params.lang).catch(() => undefined);
  },
});
